import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiMail,
  FiPhone,
  FiMapPin,
  FiHeart,
} from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-grid">

            {/* Brand Column */}
            <div className="footer-brand">
              <Link to="/" className="footer-logo-link">
                <img src="/logo.png" alt="Shammy Spices" className="footer-logo-img" />
                <h2 className="footer-logo">
                  Shammy <span className="logo-accent">Spices</span>
                </h2>
              </Link>
              <p className="footer-tagline">
                Authentic Tanzanian spices sourced directly from family farms.
                Delivered at peak freshness to your kitchen.
              </p>
              <div className="footer-contact">
                <a href="tel:+255655778989" className="contact-item">
                  <FiPhone />
                  <span>(+255) 655 778 989</span>
                </a>
                <a href="mailto:info@shammyspicestz.shop" className="contact-item">
                  <FiMail />
                  <span>info@shammyspicestz.shop</span>
                </a>
                <div className="contact-item">
                  <FiMapPin />
                  <span>Dar es Salaam, Tanzania</span>
                </div>
              </div>
            </div>

            {/* Our Spices */}
            <div className="footer-links-column">
              <h4 className="footer-links-title">Our Spices</h4>
              <ul className="footer-links-list">
                <li><Link to="/shop" state={{ category: 'All' }} className="footer-link">All Spices</Link></li>
                <li><Link to="/shop" state={{ category: 'Whole Spices' }} className="footer-link">Whole Spices</Link></li>
                <li><Link to="/shop" state={{ category: 'Powders' }} className="footer-link">Powders</Link></li>
                <li><Link to="/shop" state={{ category: 'Blends & Masala' }} className="footer-link">Blends &amp; Masala</Link></li>
                <li><Link to="/shop" state={{ category: 'Honey & Health' }} className="footer-link">Honey &amp; Health</Link></li>
              </ul>
            </div>

            {/* Company */}
            <div className="footer-links-column">
              <h4 className="footer-links-title">Company</h4>
              <ul className="footer-links-list">
                <li><Link to="/about#story" className="footer-link">Our Story</Link></li>
                <li><Link to="/about#values" className="footer-link">Our Values</Link></li>
                <li><Link to="/about#process" className="footer-link">Farm to Jar</Link></li>
                <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} Shammy Spices. Made with <FiHeart className="heart-icon" /> in Tanzania.
            </p>
            <p className="footer-founder">
              Founded by Shamsa Mohammed
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
